export enum GuarantorTypesEnum {
  Person = 2,
  Bussiness = 1,
}
